import { useEffect, useState } from "react"
import { getJts3Settings, updateJts3Settings } from "../../services/jts3Apis"
import Input from "../Input"
import { toast } from "react-toastify"

const Jts3Settings = ({ user }) => {
    const [defaultSettings, setDefaultSettings] = useState(null)

    useEffect(() => {
        if (user) {
            getJts3Settings().then(({ data }) => {
                setDefaultSettings(data || {})
            })
        }
    }, [user])

    if (!defaultSettings) {
        return null
    }

    return (
        <div className="mx-10">
            <h6 className="mb-5 mx-auto">تنظیمات Jts3:</h6>
            <form
                onSubmit={(event) => {
                    event.preventDefault()
                    const form = new FormData(event.target)
                    const data = {
                        price: form.get("price"),

                        backend: {
                            url: form.get("backend-url"),
                            token: form.get("backend-token"),
                        },
                    }
                    toast
                        .promise(updateJts3Settings(data), {
                            pending: "درحال بروزرسانی",
                            success: "به روز رسانی شد",
                            error: "Error",
                        })
                        .catch((err) => {
                            console.error(err)
                        })
                }}
            >
                <div className="mb-2">
                    <Input
                        type="number"
                        label="قیمت ساخت کاربر:"
                        name="price"
                        placeholder="10000"
                        defaultValue={defaultSettings?.price}
                        required={true}
                    />
                </div>

                <h3>تنظیمات پنل بک اند:</h3>
                <div class="border p-3 pl-6 rounded-lg">
                    <div>
                        <Input
                            type="text"
                            label="لینک بک اند"
                            name="backend-url"
                            placeholder="http://localhost:2222"
                            defaultValue={defaultSettings?.backend?.url}
                            required={true}
                        />
                    </div>
                    <div>
                        <Input
                            type="text"
                            label="توکن بک اند"
                            name="backend-token"
                            placeholder="api_token"
                            defaultValue={defaultSettings?.backend?.token}
                            required={true}
                        />
                    </div>
                </div>

                <button type="submit" className="styled-button border my-5 px-5 border-none">
                    بروزرسانی
                </button>
            </form>
        </div>
    )
}

export default Jts3Settings
